import { FC } from "react";

import TableVacantRoutes from "../../table/recruiting/tableVacantRoutesList";

interface IProps {
  title?: string;
}

const AddRouteOnVacancySection: FC<IProps> = () => {
  return (
    <div>
      <TableVacantRoutes inModal={true} />
    </div>
  );
};

export default AddRouteOnVacancySection;
